import { SubHeader } from "../../Common/layout/SubHeader";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import { PendingKYCTable } from "./PendingKYCTable";
import { PendingDocumentTable } from "./PendingDocumentTable";
import { Permissions } from "../../../util/Permissions";
import { VerifiedPendingDocument } from "./VerifiedPendingDocument";
import { VerifiedKYCTable } from "./VerifiedKYCTable";


export const PendingKYC = ({ match: { params: { userGroup } } }) => {
    return (
        <>
            <SubHeader>
                <SubHeader.Nav>
                    <SubHeader.NavItem label={"Pending"} to={`/pending-kyc/${userGroup}/pending`}>
                        <SubHeader.Nav>
                            <SubHeader.NavItem label={"Level Two Verified"} to={`/pending-kyc/${userGroup}/pending/level-two-verified`} />
                        </SubHeader.Nav>
                    </SubHeader.NavItem>
                    <SubHeader.NavItem label={"Declined"} to={`/pending-kyc/${userGroup}/declined`} />
                    <SubHeader.NavItem label={"Rejected"} to={`/pending-kyc/${userGroup}/rejected`} />
                    <SubHeader.NavItem label={"Documents"} to={`/pending-kyc/${userGroup}/documents`} />
                    <SubHeader.NavItem label={"Verified"} to={`/pending-kyc/${userGroup}/verified`} />
                </SubHeader.Nav>
            </SubHeader>
            <Switch>
                <Redirect exact={true} from="/pending-kyc/:userGroup" to="/pending-kyc/:userGroup/pending" />
                <Redirect exact={true} from="/pending-kyc/:userGroup/trove-next" to="/trove-next/:userGroup/pending" />

                <ContentRoute path="/pending-kyc/:userGroup/documents" exact permission={Permissions.PendingKYC} component={PendingDocumentTable} />
                <ContentRoute path="/pending-kyc/:userGroup/level-two-verified" exact permission={Permissions.PendingKYC} component={VerifiedPendingDocument} />
                <ContentRoute path="/pending-kyc/:userGroup/verified" exact permission={Permissions.PendingKYC} component={VerifiedKYCTable} />
                <ContentRoute path="/pending-kyc/:userGroup/:status" exact permission={Permissions.PendingKYC} component={PendingKYCTable} />
                
                
            </Switch>
        </>
    );
};
